export const pigColors = {
  0: 'blue',
  1: 'red',
  2: 'yellow',
};

export const pigIndexes = {
  blue: 0,
  red: 1,
  yellow: 2,
};
